import { useContext, useEffect, useState } from "react";
import { Alert, Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../AuthContext";
import { API_BASE_URL } from "../config";

const messageKeyForStatus = (status) => {
  if (status === "subscription_too_small") return "shiftplan.message_subscription_too_small";
  return "shiftplan.message_no_subscription";
};

export default function BillingAccessGate({ featureKey, children }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext) || {};
  // /features ist Super_Admin-only (App.js). Fuer alle anderen Rollen wuerde der
  // Button auf die Login-Seite umleiten -- dann lieber nur den Hinweis zeigen.
  const canOpenSubscriptionPage = user?.access_level === "Super_Admin";
  const [state, setState] = useState({ loading: true, hasAccess: true, status: "" });

  useEffect(() => {
    let mounted = true;
    const token = localStorage.getItem("session_token");

    const checkAccess = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/web/billing/access/${encodeURIComponent(featureKey)}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (!mounted) return;
        setState({
          loading: false,
          hasAccess: !!response.data?.has_access,
          status: response.data?.subscription_status || "no_subscription",
        });
      } catch {
        if (!mounted) return;
        setState({ loading: false, hasAccess: false, status: "no_subscription" });
      }
    };

    checkAccess();
    return () => {
      mounted = false;
    };
  }, [featureKey]);

  // Der Zugriffs-Check ist ein einzelner, schneller Request. Solange er läuft
  // bewusst nichts rendern: die gegateten Seiten (/shiftplan, /solver) bringen
  // ihren eigenen Ladezustand mit. Ein Vollbild-Spinner davor wäre nur ein
  // kurzes Aufblitzen und würde direkt vom zweiten Ladezustand abgelöst.
  if (state.loading) return null;

  if (state.hasAccess) return children;

  return (
    <Box m={2} maxWidth={720}>
      <Alert
        severity="warning"
        action={
          canOpenSubscriptionPage ? (
            <Button color="inherit" size="small" onClick={() => navigate("/features")}>
              {t("feature.title")}
            </Button>
          ) : null
        }
      >
        {t(messageKeyForStatus(state.status))}
      </Alert>
    </Box>
  );
}
